
export const COMMANDS = {
    GO: 'go',
    CART: 'cart',
    SET_CUSTOMER_ID: 'setCustomerId',
    RECOMMEND: 'recommend',
    VIEW: 'view',
    CATEGORY: 'category',
    SEARCH_TERM: 'searchTerm',
    PURCHASE: 'purchase'
}

export const LOGIC = {
    CART: 'CART',
    RELATED: 'RELATED',
    CATEGORY: 'CATEGORY',
    SEARCH: 'SEARCH',
    ALSO_BOUGHT:'ALSO_BOUGHT',
    PERSONAL:'PERSONAL',
    POPULAR: 'POPULAR'
}
export const CONTAINER_ID = {
    PERSONAL_RECS: 'personal-recs',
    CART_RECS: 'cart-recs',
    CATEGORY_RECS: 'category-recs',
    SEARCH_RECS: 'search-recs',
    ALSO_BOUGHT_RECS: 'alsobought-recs',
    POPULAR_RECS: 'popular-recs',
}